'use strict'

/* ====== CONFIG =========== */

import Routing from './routing.js'


/* ======= DEPENDENCIES ==== */

import angular from 'angular'
import ngResource from 'angular-resource'
import ngSanitize from 'angular-sanitize'
import ngRoute from 'angular-route'


/* ====== COMPONENTS ======= */

import subPage		        from './directives/sub-page/sub-page.directive.js'
import scrollResponse       from './directives/scroll-response/scroll-response.directive.js'
import scrollLock	        from './directives/scroll-lock/scroll-lock.directive.js'
import timeScroller	        from './directives/time-scroller/time-scroller.directive.js'


/* ====== SERVICES ========= */

import Langs	from './services/langs.service.js'


/* ======= STYLES =========== */

import '../style/reset.css'
import '../style/ngDialog.min.css'
import '../style/ngDialog-theme-default.min.css'
import '../style/style.css'


/* ======= APP INIT ======== */

const 
    MODULE_NAME = 'awpApp',
    APP_MODULES = [ 'ngRoute', 'ngResource', 'ngSanitize' ]

const app = angular.module(MODULE_NAME, APP_MODULES)
    //Directives
    .directive('subPage', subPage)
    .directive('scrollResponse', scrollResponse)
    .directive('scrollLock', scrollLock)
    .directive('timeScroller', timeScroller)

    //Resources & services
    .service('Langs', Langs)

//Apply config
Routing(app)

export default MODULE_NAME


// WEBPACK FOOTER //
// ./src/app/app.js